/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper';
import BoxedContainer from '../layouts/BoxedContainer';
import Icons from '../layouts/Icons';
import InstaFeed from '../../services/InstaFeed';

export default function Instagram({ data }) {
  const { title, text, instagramLink, isClip, isLarge } = data;

  const [posts, setPosts] = useState([]);
  const [swiper, setSwiper] = useState(null);
  const [currIndex, setCurrIndex] = useState(0);

  const slideNext = () => swiper.slideNext();
  const slidePrev = () => swiper.slidePrev();

  const feedId = 'e4cfede0-7e4e-4cf3-935d-f650494a9d9f';
  useEffect(() => {
    const feed = new InstaFeed(feedId);
    feed
      .get()
      .then((res) => {
        setPosts(res.posts);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  if (isEmpty(posts)) return null;
 // console.log(posts);

  return (
    <section
      className={`bg-bg-7 ${
        isClip
          ? `clip-right-top lg:-mt-20 -mt-[20px] relative z-10 lg:pt-[175px] pt-[80px]
          lg:pb-[200px] pb-[70px]`
          : 'lg:pt-[117px] pt-[70px] lg:pb-[160px] pb-[70px]'
      }
          ${isLarge ? 'lg:pb-[300px] pb-[90px]' : ''}
          `}>
      <div className="flex flex-col md:gap-y-[58px] gap-y-[30px]">
        <BoxedContainer className="regular">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex md:flex-row flex-col 2xl:gap-x-[82px] gap-x-[50px] md:items-center
            md:gap-y-0 gap-y-3">
            <a
              href="https://www.instagram.com/reel/Ch683Z6J2KE/"
              target="_blank"
              rel="noreferrer"
              className="flex 2xl:gap-x-[24px] gap-x-[10px] items-center instagram-title">
              <Icons icon="instagram-icon" className="md:w-auto w-[35px]" />{' '}
              <span
                className="text-red 3xl:text-[38px] xl:text-[32px] text-[30px] xl:leading-[63px]
              leading-[50px] font-roboto-condensed-bold uppercase">
                {title}
              </span>
            </a>

            <p
              className="2xl:max-w-[570px] max-w-[515px] 2xl:text-base text-[15px] leading-6
            text-white font-roboto-regular">
              {text}
            </p>
          </motion.div>
        </BoxedContainer>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}>
          <Swiper
            className="mySwiper relative"
            spaceBetween={20}
            centeredSlides
            loop
            autoplay={{
              delay: 2500,
            }}
            onSlideChange={(_swiper) => setCurrIndex(_swiper.activeIndex)}
            onSwiper={setSwiper}
            modules={[Autoplay]}
            slidesPerView="auto">
            {isEmpty(swiper) || (
              <>
                <button
                  type="button"
                  onClick={slideNext}
                  className={`absolute right-8 top-1/2 -translate-y-1/2 z-50 transition-all w-16
                  h-16 rounded-full bg-black bg-opacity-50 items-center justify-center
                  ${currIndex === posts.length - 1 ? 'hidden' : 'flex'}`}>
                  <i
                    className="h-4 w-4 border-b-2 border-r-2 border-white -rotate-45
                    -translate-x-1"
                  />
                </button>
                <button
                  type="button"
                  onClick={slidePrev}
                  className={`absolute left-8 top-1/2 -translate-y-1/2 z-50 transition-all w-16
                  h-16 rounded-full bg-black bg-opacity-50 items-center justify-center
                  ${currIndex === 0 ? 'hidden' : 'flex'}`}>
                  <i
                    className="h-4 w-4 border-t-2 border-l-2 border-white -rotate-45
                    translate-x-1"
                  />{' '}
                </button>
              </>
            )}
            {posts.map((item, index) => (
              <SwiperSlide key={index} className="lg:!h-[370px] !h-[290px] !aspect-square !w-fit">
                <a
                  href={item.url}
                  rel="noreferrer"
                  target="_blank"
                  aria-label="instagram images"
                  className="instagram-image:h-full aspect-square instagram-post">
                  <LazyLoadImage
                    src={item.image}
                    alt="instagram images"
                    placeholderSrc={isEmpty(item) || `${item.image}?width=50&quality=50`}
                    className="w-full h-full object-cover aspect-square"
                  />
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </section>
  );
}
